/**
 * Created by emanuele on 29/01/2017.
 */
/* eslint-disable no-constant-condition */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import reactCSS from 'reactcss'
import { SketchPicker } from 'react-color';

class ColorPicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayColorPicker: false,
            color: this.props.value,
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if (this.props.value !== nextProps.value)
        {
            this.setState({color: nextProps.value});
        }
    }

    handleClick() {
        this.setState({ displayColorPicker: !this.state.displayColorPicker })
    }

    handleClose()  {
        this.setState({ displayColorPicker: false })
    }

    handleChange(color) {
        this.setState({ color: color.hex })
        if (this.props.onChange !== undefined)
        {
            this.props.onChange(undefined, {name: this.props.name, value: color.hex});
        }
    }

    render() {
        const styles = reactCSS({
            'default': {
                popover: {
                    position: 'absolute',
                    zIndex: '2',
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
            },
        });
        return (
            <div>
                <div className="ui input" style={ {cursor: 'pointer'} } onClick={ this.handleClick }>
                    <input name={this.props.name} style={{backgroundColor: this.state.color, cursor: 'pointer'}} readOnly="true" ></input>
                </div>
                { this.state.displayColorPicker ? <div style={ styles.popover }>
                        <div style={ styles.cover } onClick={ this.handleClose }/>
                        <SketchPicker color={ this.state.color } onChange={ this.handleChange } />
                    </div> : null }

            </div>
        )
    }
}


ColorPicker.PropTypes = {
    className: PropTypes.string,
    autoFocus: PropTypes.bool,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func
};

ColorPicker.defaultProps = {
    value: '#000000'
};
export default ColorPicker;



/** WEBPACK FOOTER **
 ** ./src/components/ColorPicker.js
 **/